<template>
    <Popup ref="popup" type="bottom" align="center" show-close title="请上传本人免冠大头照">
        <div class="uploadPortraitPhoto">
            <div class="uploadPortraitPhoto_desc">
                <img src="@/assets/images/portrait_photo_example@2x.png" />
                <slot #desc><div class="text" v-if="desc">{{desc}}</div></slot>
            </div>
            <div class="operation_list">
                <div class="item">
                    <span>手机拍照上传</span>
                    <div class="button" @click="uploadPortraitPhoto(1)">去拍照</div>
                </div>
                <div class="item">
                    <span>从手机相册选择</span>
                    <div class="button" @click="uploadPortraitPhoto(2)">去选择</div>
                </div>
            </div>
        </div>
    </Popup>
</template>

<script>
    import appInteraction from '../common/appInteraction';

    import Popup from './Popup.vue';
    export default {
		name: 'UploadPortraitPhoto',
        components: {
            Popup
        },
		props: {
			ossConfig: Object,
			desc: String
		},
		data(){
			return {}
		},
		methods: {
			close(){
				this.$refs.popup.close();
			},
			open(){
                console.log(this.$refs.popup);
				this.$refs.popup.open();
			},
			//选择
			choose(){
				this.open();
				return new Promise((resolve, reject)=>{
					this.resolve = resolve;
					this.reject = reject;
				})
			},
			uploadPortraitPhoto(type){
                appInteraction.updatePortrait({
                    ...this.ossConfig,
                    Menu: type,
                    Resolutions:'295,413'
                }).then(data=>{
                    this.resolve(data.Url);
                }).catch(this.reject).finally(this.close);
			}
		}
	}
</script>

<style lang="scss" scoped>
    .uploadPortraitPhoto{
		height: auto;
		width: 100%;
        padding-top: 40px;
        padding-bottom: 58px;
		box-sizing: border-box;
		.uploadPortraitPhoto_desc{
			margin-bottom: 60px;
			img{
				width: 236px;
				height: 308px;
				display: block;
				margin: 0 auto;
			}
			.text{
				font-family: PingFangSC-Regular;
				font-size: 28px;
				color: #666666;
				line-height: 20px;
				font-weight: 400;
				margin-top: 24px;
				text-align: center;
			}
		}
		.operation_list{
			width: 100%;
			padding: 0 40px;
			box-sizing: border-box;
			.item{
				width: 100%;
				height: 112px;
				padding: 0 24px 0 32px;
				box-sizing: border-box;
				background: #FAFBFA;
				border-radius: 20px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 20px;
				&:last-of-type{
					margin-bottom: 0;
				}
				&:first-of-type .button{
					background: #FEF1CD;
					color: #ED8A03;
				}
				span{
					font-family: PingFangSC-Regular;
					font-size: 28px;
					color: #1B1C1E;
					font-weight: 400;
				}
				.button{
					width: 140px;
					height: 56px;
					background: #EDF6FF;
					border-radius: 28px;
					font-family: PingFangSC-Medium;
					font-size: 28px;
					color: #5390F6;
					font-weight: 500;
					line-height: 56px;
					text-align: center;
				}
			}
		}
	}
</style>